import {
    Box,
    Checkbox,
    FormControlLabel,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";

interface ListExternalSystemLineProps {
  code: string;
  name: string;
  checked: boolean;
  value: string;
  rootUrl?: string;
  usesExternalCode?: boolean;
  onCheckChange: (code: string, value: boolean) => void;
      onInputChange?: (event: any) => void;
}

export const ListExternalSystemLine = ({
    code,
    name,
    checked,
    value,
    rootUrl,
    usesExternalCode = true,
    onCheckChange,
    onInputChange,
}: ListExternalSystemLineProps) => {
    return (
        <Grid container key={code}>
            <Grid item sm={7} display="flex" alignItems="center">
                <FormControlLabel
                    label={
                        <Box display="flex">
                            {rootUrl && (
                                <Box
                                    component="img"
                                    alt="..."
                                    src={rootUrl + "Content/" + code + ".png"}
                                    sx={{ marginRight: ".5rem" }}
                                />
                            )}
                            <Typography>{name}</Typography>
                        </Box>
                    }
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={(_e, checked: boolean) => onCheckChange(code, checked)}
                        />
                    }
                />
            </Grid>
            <Grid item sm={5} sx={{ display: "flex", minHeight: "56px" }}>
                {usesExternalCode && (
                    <TextField
                        type="text"
                        name={code}
                        title={Translations.ExternalSystemCode}
                        inputProps={{ maxLength: 50 }}
                        disabled={false}
                        value={value}
                        onChange={onInputChange}
                        sx={{ margin: ".5rem 0" }}
                        fullWidth
                    />
                )}
            </Grid>
        </Grid>
    );
};
